import { Box, Typography, styled } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-scroll";

const RotatedTypography = styled(Typography)({
  transform: "rotate(-90deg)",
  whiteSpace: "nowrap",
  fontSize: 10,
  letterSpacing: 5,
  display: "inline-block",
  "&:hover": {
    textDecoration: "line-through",
  },
});

function Socials() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 3,
      }}
    >
      <Box height={85}>
        <a
          href="https://www.linkedin.com/in/polinachebanenko/"
          target="_blank"
          rel="noopener noreferrer"
          className="link"
          style={{
            color: "inherit",
            textDecoration: "none",
            display: "block",
          }}
        >
          <RotatedTypography>LINKEDIN</RotatedTypography>
        </a>
      </Box>
      <Box height={85}>
        <a
          href="https://github.com/apoolinaria"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "inherit", textDecoration: "none", display: "block" }}
        >
          <RotatedTypography>GITHUB</RotatedTypography>
        </a>
      </Box>
    </Box>
  );
}

export default function NavBar() {
  const location = useLocation();
  const [showSocials, setShowSocials] = useState(true);

  const handleToTop = () => {
    const currentURL = window.location.href;
    const modifiedURL = currentURL.split("#")[0];
    window.history.replaceState({}, document.title, modifiedURL);
    setShowSocials(true);
  };

  useEffect(() => {
    if (location.hash === "") {
      setShowSocials(true);
    } else {
      setShowSocials(false);
    }
  }, [location]);

  return (
    <Box
      sx={{
        width: "50px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "center",
        position: "fixed",
        paddingTop: 15,
        top: 0,
        bottom: 0,
      }}
    >
      {showSocials ? (
        <Socials />
      ) : (
        <Box height={85}>
          <Link
            to="top"
            smooth={true}
            duration={500}
            style={{ color: "inherit", textDecoration: "none" }}
            onClick={handleToTop}
          >
            <RotatedTypography>HOME</RotatedTypography>
          </Link>
        </Box>
      )}
      <div
        style={{
          paddingTop: 10,
          borderRight: "1px solid",
          height: "80px",
        }}
      ></div>
    </Box>
  );
}
